import {AbstractModel} from './abstract-model';

export class CustomPayoutSubId extends AbstractModel {
  subId!: string;

  override toString(): string {
    return this.subId;
  }
}
